module.exports = __webpack_public_path__ + "img/its_me.e301a89c.jpg";